import Service from "../../../Services/index";

const Shipping = {
    namespaced: true,
    state: {
        customer_shipping: [],
        customer_shipping_sub: [],
        shipping_fee: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        selected: [],
        search: {
            customer: null,
            area: null,
            province: null,
            district: null,
            sub_districts: null,
            sale: null,
            distance_order: '',
        },
    },
    mutations: {
        SET_CUSTOMER_SHIPPING: (state, res) => {
            state.customer_shipping = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_CUSTOMER_SHIPPING_SUB: (state, res) => {
            state.customer_shipping_sub = res[0].data;
            state.dataPaginate = {
                current_page: res[0].current_page,
                from: res[0].form,
                last_page: res[0].last_page,
                per_page: res[0].per_page,
                total: res[0].total,
                to: res[0].to
            };
        },
        SET_SHIPPING_FEE: (state, res) => {
            state.shipping_fee = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_SELECT_ALL: (state, res) => {
            state.selected = res;
        },
        CLEAR_SEARCH: (state) => {
            state.selected = [];
            state.search = {
                customer: null,
                area: null,
                province: null,
                district: null,
                sub_district: null,
                sale: null,
                distance_order: '',
            }
        }
    },
    actions: {
        getCustomerShipping({commit}, {page = 1, data}) {
            return Service.Shipping.searchCustomerShipping(page, data).then(res => {
                commit("SET_CUSTOMER_SHIPPING", res);
            })
        },
        getCustomerSubShipping({commit}, {page = 1, data}) {
            return Service.Shipping.searchCustomerSubShipping(page, data).then(res => {
                commit("SET_CUSTOMER_SHIPPING_SUB", res);
                return res;
            })
        },
        setShipping({commit}, page = 1) {
            return Service.Shipping.getShipping(page)
                .then(data => {
                    commit("SET_SHIPPING_FEE", data);
                });
        },
        create({commit}, data) {
            return Service.Shipping.createShipping(data)
        },
        createSub({commit}, data) {
            return Service.Shipping.createShippingSub(data)
                .then(res => {
                    //console.log(res);
                })
        },
        search({commit}, {page = 1, date}) {
            return Service.Shipping.searchEditShipping(page, date)
                .then(res => {
                    commit("SET_SHIPPING_FEE", res);
                })
        },
        selectAllAPI({commit}, search) {
            return Service.Shipping.selectAll(search)
                .then(res => {
                    return res
                })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        }
    }
};

export default Shipping;
